export default __webpack_public_path__ + "static/media/RegisterWait3.c2f0fe6d.JPG";